import { Theme } from '@emotion/react';

export const generateInputStyles = (theme: Theme) => ({
    input: {
        width: '100%',
        border: `1px solid ${theme.palette.secondary.lightGrey}`,
        padding: '6px 6px',
        color: theme.palette.common.black,
    },
});
